module.exports = __webpack_public_path__ + "img/68.e77fe8a2.jpg";